import { mapMatchStatus, processTestFiltersResponse } from '../strategy/testFiltersStrategyUtils';
export const parseDebugFilterBranchEvaluationResponse = (response, objectTypeId, internalDraftValue) => {
  if (!response || !Array.isArray(response)) {
    return undefined;
  }
  const filtersStatus = mapMatchStatus(response[0]['@ok'].acceptedStatus);
  const branches = response[0]['@ok'].filterBranches;
  const result = branches.map(group => {
    const obj = {
      status: mapMatchStatus(group.acceptedStatus),
      filtersData: group.filters.map(filter => {
        const evaluationData = filter.evaluationData[0];
        const filterDataObject = {
          filterType: filter.filter && filter.filter.filterType,
          firstMatchingPropertyValue: evaluationData && evaluationData.matchingPropertyValuesOrdered && evaluationData.matchingPropertyValuesOrdered[0],
          firstNonMatchingPropertyValue: evaluationData && evaluationData.nonMatchingPropertyValuesOrdered && evaluationData.nonMatchingPropertyValuesOrdered[0],
          matchingFilterValues: evaluationData && evaluationData.matchingFilterValues,
          operator: filter.filter && filter.filter.operation && filter.filter.operation.operator,
          propertyValue: evaluationData && (evaluationData.propertyValue || evaluationData.propertyValueHistory),
          status: mapMatchStatus(filter.acceptedStatus)
        };
        return filterDataObject;
      }),
      filterBranchesData: group.filterBranches.map(filter => mapMatchStatus(filter.acceptedStatus))
    };
    return obj;
  });
  const filtersData = processTestFiltersResponse(objectTypeId, internalDraftValue, result);
  return {
    filtersData,
    filtersStatus
  };
};